"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapUtils = void 0;
/** @ignore */
var THREE = require("../../externals/three");
var GLOBAL_UTILS = __importStar(require("../../shared/util/GlobalUtils"));
var SnapUtils = /** @class */ (function () {
    function SnapUtils() {
    }
    SnapUtils.prototype.sortDistance = function (array) {
        array.sort(function (a, b) {
            return a.snapInfo.distance - b.snapInfo.distance;
        });
    };
    SnapUtils.prototype.sortDot = function (array) {
        array.sort(function (a, b) {
            return b.dot - a.dot;
        });
    };
    SnapUtils.prototype.createRandomId = function () {
        return Math.random().toString(36).substring(7);
    };
    SnapUtils.prototype.cleanPointInput = function (def) {
        var out = {};
        if (!def)
            return out;
        out.anchorElements = GLOBAL_UTILS.isArrayOfType(def.anchorElements, 'string') ? def.anchorElements : [];
        out.id = GLOBAL_UTILS.typeCheck(def.id, 'string') ? def.id : this.createRandomId();
        out.orientation = this.cleanOrientation(def.orientation);
        out.position = this.cleanPosition(def.position);
        out.snapRadius = GLOBAL_UTILS.typeCheck(def.snapRadius, 'notnegative') ? def.snapRadius : 1;
        return out;
    };
    SnapUtils.prototype.cleanLineInput = function (def) {
        var out = {};
        if (!def)
            return out;
        out.anchorElements = GLOBAL_UTILS.isArrayOfType(def.anchorElements, 'string') ? def.anchorElements : [];
        out.id = GLOBAL_UTILS.typeCheck(def.id, 'string') ? def.id : this.createRandomId();
        out.orientation = this.cleanOrientation(def.orientation);
        out.positionEnd = this.cleanPosition(def.positionEnd);
        out.positionStart = this.cleanPosition(def.positionStart);
        out.snapRadius = GLOBAL_UTILS.typeCheck(def.snapRadius, 'notnegative') ? def.snapRadius : 1;
        return out;
    };
    SnapUtils.prototype.cleanAnchorInput = function (def) {
        var out = {};
        if (!def)
            return out;
        out.id = GLOBAL_UTILS.typeCheck(def.id, 'string') ? def.id : this.createRandomId();
        out.position = this.cleanPosition(def.position);
        out.orientation = this.cleanOrientation(def.orientation);
        return out;
    };
    SnapUtils.prototype.cleanPosition = function (position) {
        var out = new THREE.Vector3();
        if (GLOBAL_UTILS.typeCheck(position, 'vector3any'))
            out = GLOBAL_UTILS.toVector3(position);
        return out;
    };
    SnapUtils.prototype.cleanOrientation = function (orientation) {
        var out = {
            axis: new THREE.Vector3(0, 0, 1),
            direction: new THREE.Vector3(0, 1, 0),
        };
        if (orientation) {
            if (GLOBAL_UTILS.typeCheck(orientation.axis, 'vector3any'))
                out.axis = GLOBAL_UTILS.toVector3(orientation.axis);
            if (GLOBAL_UTILS.typeCheck(orientation.direction, 'vector3any'))
                out.direction = GLOBAL_UTILS.toVector3(orientation.direction);
        }
        return out;
    };
    return SnapUtils;
}());
exports.SnapUtils = SnapUtils;
